import {BrowserRouter as Router} from "react-router-dom";
import * as React from "react";
import Routers from "./main/partials/Routers";

import moment from 'moment';
import 'moment/locale/tr';

moment.locale(window._locale);

class App extends React.Component {

    render() {
        return (
            <Router>
                <Routers/>
            </Router>
        );
    }
}

export default App;
